"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateStringParserNode = void 0;
const BaseNode_1 = require("../../BaseNode");
const Schema = __importStar(require("./schema.json"));
const NODE_TYPE = 'DATE-STRING-PARSER';
class DateStringParserNode extends BaseNode_1.BaseNode {
    constructor() {
        super(...arguments);
        this._resolve = (params) => {
            const { source } = params;
            let date = null;
            let dateNumber = null;
            let timeNumber = null;
            if (source) {
                if (source instanceof Date) {
                    date = source;
                }
                else if (typeof source === 'number') {
                    date = new Date(source);
                }
                else if (typeof source === 'string') {
                    const dateNumber = Date.parse(source);
                    if (dateNumber) {
                        date = new Date(dateNumber);
                    }
                }
            }
            // now grab the dateNumber and timeNumber from the date
            if (date) {
                // date number is the milliseconds to midnight, UTC of the selected date
                dateNumber = Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
                //time number is the remainder
                timeNumber = date.getTime() - dateNumber;
            }
            return { output: date, dateNumber, timeNumber };
        };
        //TODO: Build the interface definition from the given schema....but what is our schema
        this._interfaceDefinition = Schema;
    }
}
exports.DateStringParserNode = DateStringParserNode;
DateStringParserNode._nodeDefinition = {
    NODE_TYPE,
    defaultTitle: 'Date String Parser',
    isIdempotent: true,
    primaryCategory: 'Date/Time',
};
//# sourceMappingURL=DateStringParser.js.map